
(function() {
  var POPUP_KEY = 'luv_newsletter_popup_seen_v1';

  function openPopup() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;
    popup.classList.add('is-visible');
  }

  function closePopup() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;
    popup.classList.remove('is-visible');
    try {
      var expires = new Date();
      expires.setDate(expires.getDate() + 7);
      document.cookie = POPUP_KEY + '=1; path=/; expires=' + expires.toUTCString();
    } catch (e) {}
  }

  function hasSeenPopup() {
    return document.cookie.indexOf(POPUP_KEY + '=1') !== -1;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var triggerLink = document.querySelector('[data-open-discount-popup]');
    if (triggerLink) {
      triggerLink.addEventListener('click', function(e) {
        e.preventDefault();
        openPopup();
      });
    }

    var closeBtn = document.querySelector('[data-newsletter-close]');
    var overlay = document.querySelector('[data-newsletter-overlay]');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    if (!hasSeenPopup()) {
      setTimeout(openPopup, 2500);
    }
  });
})();
